import { Skeleton } from '@crehana/compass.ui/v3/skeleton';
import {
  PageLayout,
  PageLayoutContent,
  PageLayoutTop,
} from '@crehana/compass.web/page-layout';

const ROW_SKELETON_KEYS = [
  'row-1',
  'row-2',
  'row-3',
  'row-4',
  'row-5',
  'row-6',
];

export const UserAttendanceMyRequestsLoading = () => {
  return (
    <PageLayout>
      <PageLayoutTop>
        <div className="tw-flex tw-items-end tw-justify-between tw-cds-gap-4">
          <div className="tw-flex tw-flex-col tw-cds-gap-3">
            <Skeleton.Block className="tw-h-[3.2rem] tw-w-[24rem]" />
            <Skeleton.Block className="tw-h-[1.8rem] tw-w-[40rem]" />
          </div>
          <Skeleton.Block className="tw-h-[4rem] tw-w-[16rem]" />
        </div>
      </PageLayoutTop>
      <PageLayoutContent>
        <div className="tw-flex tw-flex-col tw-cds-gap-3">
          <Skeleton.Block className="tw-h-[4.8rem] tw-w-full" />
          {ROW_SKELETON_KEYS.map(key => (
            <Skeleton.Block key={key} className="tw-h-[5.6rem] tw-w-full" />
          ))}
        </div>
      </PageLayoutContent>
    </PageLayout>
  );
};
